var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{attrs:{"gutter":16}},[_c('Col',{attrs:{"span":12}},[_c('study-info',{attrs:{"model":_vm.model}})],1),_c('Col',{attrs:{"span":12}},[_c('study-sites',{attrs:{"model":_vm.model}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }